import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Stack,
} from '@chakra-ui/react';

const ResendConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  email,
  isLoading,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Resend Invitation</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to resend the invitation to{' '}
            <strong>{email}</strong>?
          </Text>
        </ModalBody>

        <ModalFooter>
          <Stack
            spacing="10px"
            direction={{ base: 'column', sm: 'row' }}
            width={{ base: 'full', sm: 'auto' }}
          >
            <Button
              onClick={onClose}
              alt="Cancel"
              variant="secondary"
              width={{ base: 'full', sm: 'auto' }}
              isDisabled={isLoading}
            >
              <Text>Cancel</Text>
            </Button>
            <Button
              alt="Resend"
              width={{ base: 'full', sm: 'auto' }}
              onClick={onConfirm}
              isLoading={isLoading}
              isDisabled={isLoading}
            >
              Resend
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ResendConfirmationModal;
